import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { RouterModule } from '@angular/router';
import { ProjectFilesTreeModule } from '@portal-core/project-files/components/project-files-tree/project-files-tree.module';
import { IsProjectFileEditableModule } from '@portal-core/project-files/pipes/is-project-file-editable/is-project-file-editable.module';
import { WorkspaceFilesTreeComponent } from '@portal-core/project-files/workspace/components/workspace-files-tree/workspace-files-tree.component';
import { ContextMenuItemsModule } from '@portal-core/ui/grid/directives/context-menu-items/context-menu-items.module';
import { FilterBarModule } from '@portal-core/ui/page-filters/components/filter-bar/filter-bar.module';

@NgModule({
  declarations: [WorkspaceFilesTreeComponent],
  imports: [
    CommonModule,
    ProjectFilesTreeModule,
    FilterBarModule,
    IsProjectFileEditableModule,
    ContextMenuItemsModule,
    RouterModule,
    MatMenuModule,
    MatButtonModule
  ],
  exports: [
    WorkspaceFilesTreeComponent
  ]
})
export class WorkspaceFilesTreeModule { }
